import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@hooks/useAuth";
import { LoadingSpinner } from "@components/common";

export const WrikeCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { processWrikeCallback } = useAuth();
  const [message, setMessage] = useState("Processando autenticação...");

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const error = searchParams.get("error");
      const errorDescription = searchParams.get("error_description");

      // Se o state contém uma origem de dev (ex: http://localhost:3000),
      // redireciona para lá com o code para que o dev local processe o login.
      // Isso permite usar o redirect_uri de produção registrado no Wrike
      // e ainda assim testar localmente.
      if (state && code) {
        try {
          const devOrigin = new URL(state);
          // Só redireciona se for localhost (segurança)
          if (
            devOrigin.hostname === "localhost" ||
            devOrigin.hostname === "127.0.0.1"
          ) {
            const devCallbackUrl = `${devOrigin.origin}/auth/wrike/callback?code=${encodeURIComponent(code)}`;
            window.location.href = devCallbackUrl;
            return;
          }
        } catch {
          // state não é uma URL válida — ignora e processa normalmente
        }
      }

      if (error) {
        console.error("Erro no OAuth:", error, errorDescription);
        navigate(`/login?error=wrike_auth_failed`);
        return;
      }

      if (!code) {
        console.error("Código de autorização não encontrado");
        navigate("/login?error=no_code");
        return;
      }

      try {
        setMessage("Validando credenciais...");

        // Processar código de autorização
        await processWrikeCallback(code);

        setMessage("Login realizado com sucesso! Redirecionando...");

        // Aguardar um momento para mostrar mensagem de sucesso
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } catch (err: any) {
        console.error("Erro ao processar callback:", err);

        // Verificar tipo de erro
        const errorMessage = err?.response?.data?.message || err?.message || "";

        if (
          errorMessage.includes("domínio") ||
          errorMessage.includes("domain")
        ) {
          navigate("/login?error=invalid_domain");
        } else {
          navigate("/login?error=callback_failed");
        }
      }
    };

    handleCallback();
  }, [searchParams, navigate, processWrikeCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:p-8 bg-base-200">
      <div className="card bg-base-100 shadow-2xl w-full max-w-md">
        <div className="card-body items-center text-center">
          <LoadingSpinner size="large" />
          <h2 className="text-xl font-semibold mt-4 text-base-content">
            {message}
          </h2>
          <p className="text-base-content/60 mt-2">Por favor, aguarde...</p>
        </div>
      </div>
    </div>
  );
};
